import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { PageHero } from '../components/PageHero';
import { PricingMenus } from '../components/PricingMenus';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/effac2ed-f9bc-4696-a4cc-3e2cc7a1e8da.jpg';
const INCLUSIONS = ['Clean, private treatment room', 'Fresh linen for every client', 'Choice of pressure — light, medium or firm', 'Warm oil and towel service', 'No appointment required for walk-ins', 'Open seven days until late'];
export function Services() {
  return <main className="w-full bg-black" data-id="element-323" data-mp="b2zwxdezq50t">
      <PageHero image={HERO_IMAGE} eyebrow="The Menu" title="Services & Pricing" subtitle="Professional massage, tailored to how you like it." data-id="element-324" data-mp="b1yhkwqxywda" />

      <section aria-labelledby="pricing-heading" className="w-full bg-black" data-id="element-325" data-mp="2cvo23sb732j8">
        <div className="mx-auto w-full max-w-5xl px-5 py-20 sm:px-8" data-id="element-326" data-mp="27xmjt9llf78t">
          <PricingMenus data-id="element-327" data-mp="16pcnw6ha8dac" />
        </div>
      </section>

      <section aria-labelledby="inclusions-heading" className="w-full bg-ink-950" data-id="element-328" data-mp="16qnoxyjcf6xr">
        <div className="mx-auto w-full max-w-5xl px-5 py-20 sm:px-8" data-id="element-329" data-mp="1bofhmurtax30">
          <h2 id="inclusions-heading" className="text-3xl font-bold tracking-tight text-white sm:text-4xl" data-id="element-330" data-mp="1fp94rlxfk7uu">
            What's included
          </h2>
          <ul className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-331" data-mp="1pfu1f3tjn2b4">
            {INCLUSIONS.map(item => <li key={item} className="flex items-start gap-3 rounded-xl border border-white/5 bg-ink-850 p-5 text-neutral-300" data-id="element-332" data-mp="1udvvejsicm1d">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-lotus-500" aria-hidden="true" data-id="element-333" data-mp="23f3h82du7uek" />
                {item}
              </li>)}
          </ul>
          <div className="mt-12 text-center" data-id="element-334" data-mp="51a9f3ozez8l">
            <Link to="/book" className="inline-flex items-center justify-center gap-2 rounded-lg bg-lotus-500 px-8 py-4 text-base font-semibold text-black transition-colors hover:bg-lotus-600" data-id="element-335" data-mp="90j1m44dip21">
              Book Now
              <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-336" data-mp="17ezqpemjsmnc" />
            </Link>
          </div>
        </div>
      </section>
    </main>;
}